<ion-content class="ion-padding">
  <div class="access-denied-container">
    <div class="icon-badge">
      <ion-icon name="lock-closed-outline"></ion-icon>
    </div>
    <h1>Access restricted</h1>
    <p class="message">
      You don't currently have permission to view this page. If you think this
      is a mistake, please reach out to your administrator and we'll help sort it
      out.
    </p>
    <ion-button expand="block" shape="round" class="action" (click)="goBack()">
      <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
      Go back
    </ion-button>
    <ion-button
      expand="block"
      shape="round"
      fill="outline"
      class="action"
      (click)="logout()"
    >
      <ion-icon slot="start" name="log-out-outline"></ion-icon>
      Sign in as another user
    </ion-button>
  </div>
</ion-content>
